import React from "react";
// import { useNavigate } from "react-router-dom";
import Top from "../../Top";
import Left from "../../Left";
import { Grid } from "@mui/material";
// import PaidInvoicesListingTable from "./PaidInvoicesListingTable";
// import CreateInvoiceNewList from "./CreateInvoiceNewList";
import PaidInvoiceNewList from "./PaidInvoiceNewList";

function PaidInvoicesListing() {
  // const navigate = useNavigate();
  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12} className="oneLineBt">
            <h1 className="panelHeading">Paid Invoice</h1>
            {/* <Button
              className="contentTopLefBt addCommiteeBt"
              onClick={() => navigate("/CreateInvoice")}
            >
              Create New Invoice
            </Button> */}
          </Grid>
          <Grid item xs={12} md={12}>
            <div className="residentManagementTable">
              {/* <PaidInvoicesListingTable /> */}
              <PaidInvoiceNewList />
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
}

export default PaidInvoicesListing;
